import { ClientLocationModel } from './clientLocationModel';
import { ClientModel } from "./clientModel";

export class ClientSearchModel {
    public client: ClientModel;
    public locations: Array<ClientLocationModel>;
}